export default __webpack_public_path__ + "static/media/HR.0c1d7ba0.jpg";